package team.platforma.dictionary_domain.di

import org.koin.dsl.module
import team.platforma.dictionary_domain.use_case.ai_chapter.AiChapterTableUseCase
import team.platforma.dictionary_domain.AiChapterUseCase
import team.platforma.dictionary_domain.AiModelUseCase
import team.platforma.dictionary_domain.use_case.ai_chapter.NetworkAiChapterUseCase
import team.platforma.dictionary_domain.use_case.ai_model.AiModelTableUseCase
import team.platforma.dictionary_domain.use_case.ai_model.NetworkAiModelUseCase

val dictionaryDomainModule = module {
    single {
        AiChapterUseCase(
            network = NetworkAiChapterUseCase(repository = get()),
            table = AiChapterTableUseCase(repository = get())
        )
    }

    single {
        AiModelUseCase(
            network = NetworkAiModelUseCase(repository = get()),
            table = AiModelTableUseCase(repository = get())
        )
    }
}